var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { staticStyle: { "white-space": "nowrap" } },
    [
      _vm.$store.getters.companyContext === null
        ? [
            _vm.$store.getters.hasPermission("travelOrderPreview")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/all" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("content_copy")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Zamówienia")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("travelOrderResponseHotel")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/by-type/hotel" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("hotel")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Zamówienia hotelowe")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("travelOrderResponseFlight")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/by-type/flight" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("flight")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Zamówienia lotnicze")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("travelOrderResponseFlightLowCost")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/by-type/low-cost" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("near_me")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v("Zamówienia tanie linie lotnicze")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("travelOrderResponseCar")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/by-type/car" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("drive_eta")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Zamówienia samochodów")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("travelOrderResponseRail")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/by-type/rail" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("directions_railway")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Zamówienia kolejowe")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("travelOrderResponseInsurance")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/by-type/insurance" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("local_pharmacy")])],
                      1
                    ),
                    _c("v-list-item-content", [
                      _vm._v("Zamówienia ubezpieczenia")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("travelOrderResponseOther")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/travel-service/by-type/other" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("fa-directions")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Zamówienia specjalne")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("manageCompanies")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/companies" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("business")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Lista firm")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("mainDbUserManage")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/users" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("people")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Lista użytkowników")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("manageMailingList")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/mailing" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("email")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Listy mailingowe")])
                  ],
                  1
                )
              : _vm._e(),
            _vm.$store.getters.hasPermission("mainDbSettings")
              ? _c(
                  "v-list-item",
                  { attrs: { to: "/admin/system-settings" } },
                  [
                    _c(
                      "v-list-item-action",
                      [_c("v-icon", [_vm._v("fa-cog")])],
                      1
                    ),
                    _c("v-list-item-content", [_vm._v("Ustawienia systemowe")])
                  ],
                  1
                )
              : _vm._e()
          ]
        : [
            _c(
              "v-list-item",
              [
                _c(
                  "v-list-item-action",
                  [
                    _c("v-icon", { attrs: { color: "error" } }, [
                      _vm._v("fa-exclamation-circle")
                    ])
                  ],
                  1
                ),
                _c("v-list-item-content", [
                  _vm._v("Firma: " + _vm._s(_vm.$store.getters.companyContext))
                ])
              ],
              1
            ),
            _c("main-menu-standalone"),
            _c(
              "v-list-item",
              { on: { click: _vm.loginBack } },
              [
                _c(
                  "v-list-item-action",
                  [_c("v-icon", [_vm._v("transfer_within_a_station")])],
                  1
                ),
                _c("v-list-item-content", [
                  _vm._v("Wróć na konto administracyjne")
                ])
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }